function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
  fill: "#E6F7FD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 16.5C6.69531 16.5 4 13.8047 4 10.5C4 7.19531 6.69531 4.5 10 4.5C13.3047 4.5 16 7.19531 16 10.5C16 13.8047 13.3047 16.5 10 16.5ZM10 5.625C7.30469 5.625 5.125 7.80469 5.125 10.5C5.125 13.1953 7.30469 15.375 10 15.375C12.6953 15.375 14.875 13.1953 14.875 10.5C14.875 7.80469 12.6953 5.625 10 5.625ZM11.6641 8.48438C11.8516 8.22656 12.2031 8.17969 12.4375 8.36719C12.6953 8.53125 12.7422 8.88281 12.5781 9.14062L9.69531 13.0781C9.60156 13.2188 9.46094 13.2891 9.29688 13.3125C9.13281 13.3125 8.96875 13.2656 8.85156 13.1484L7.53906 11.8359C7.32812 11.625 7.32812 11.2734 7.53906 11.0391C7.77344 10.8281 8.125 10.8281 8.33594 11.0391L9.17969 11.8828L11.6641 8.48438Z",
  fill: "#006CA3"
});

function SvgTickBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBox);
export default __webpack_public_path__ + "static/media/tick-box.cb0aa36d.svg";
export { ForwardRef as ReactComponent };